<template>
    <v-chip 
      :close="closable" 
      :closable="closable" 
      close-icon="icon-close-small" 
      :color="getBackgroundColor"
      :text-color="getTextColor"
      @click:close="$emit('click:close', label)"
      @click="$emit('click', label)"
      :title="label?.name"
      class="d-tag-chip text-truncate"
      pill>
      <span class="text-truncate">{{ label?.name ?? '' }}</span>
    </v-chip>
</template>
<script lang="ts">
import { getRandomTagColor } from "@/helpers/tags";
export default {
    components: {
    },
    props: {
      label: {
        type: Object,
        required: true,
      },
      closable: {
        type: Boolean,
        default: false,
      }
    },
    data() {
        return {};
    },
    methods: {
      convertHexToRGB(hexColor: string) : number[] {
        const r = parseInt(hexColor.slice(1, 3), 16);
        const g = parseInt(hexColor.slice(3, 5), 16);
        const b = parseInt(hexColor.slice(5, 7), 16);
        return [r, g, b];
      },
      darkenColor (hexColor : string, amount : number = 50) {
        let [r, g, b] = this.convertHexToRGB(hexColor);        
        // There are a few colors chosen that look better with darker text. 
        if (this.isColorTooLight(hexColor)) {
          amount += 50;
        }

        // Darken each color
        r = Math.max(0, r - amount);
        g = Math.max(0, g - amount);
        b = Math.max(0, b - amount);
        
        // Convert back to hex
        return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
      },
      isColorTooLight (hexColor : string) {
        let [r, g, b] = this.convertHexToRGB(hexColor);     
        
        // Calculate relative luminance using WCAG formula
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        
        // If luminance is too high, the text needs to be darkened for readability
        return luminance > 0.7;
      }
    },
    computed: {
      getBackgroundColor () {
        const hexColor = this.label.baseColor ?? getRandomTagColor();
        let [r, g, b] = this.convertHexToRGB(hexColor);
        return `rgba(${r}, ${g}, ${b}, 0.3)`;
      },
      getTextColor () {
        const hexColor = this.label.baseColor ?? getRandomTagColor();
        return this.darkenColor(hexColor)
      }
    }
}
</script>